import { sitesApi } from '@/lib/api/sites';
import { siteNameError } from './workSiteNames';
export { suggestedSiteName, suggestedHtmlFilename, siteNameError } from './workSiteNames';

// Shared by inline cards and artifact viewers. Publication never starts a
// model turn or resumes the task; the server reads the selected saved artifact.
const submitting = new Set();
export async function requestSitePublication({ taskId, name, file, artifact, prepareFile, replaceExisting = false }) {
  const fileId = file?.id || file?._id || artifact?.fileId;
  const artifactPath = artifact?.path || file?.parameters?.workArtifactPath;
  if (!fileId && !(taskId && artifactPath) && !prepareFile) throw new Error('Open or save this HTML creation to publish it.');
  const validation = siteNameError(name);
  if (validation) throw new Error(validation);
  const key = fileId ? `file:${fileId}` : taskId ? `task:${taskId}` : prepareFile;
  if (submitting.has(key)) throw new Error('This creation is already being published. Please wait.');
  submitting.add(key);
  try {
    const prepared = !fileId && prepareFile ? await prepareFile() : file;
    const savedId = prepared?.id || prepared?._id || fileId;
    if (!savedId && !(taskId && artifactPath)) throw new Error('This creation could not be saved. Please try again.');
    const out = await sitesApi.publish({ ...(taskId ? { taskId } : {}), name, ...(savedId ? { fileId: String(savedId) } : { artifactPath }), replaceExisting });
    if (out?.site?.name !== name || out.site.status !== 'live' || !out.site.url) throw new Error('Publication has not been confirmed. Check My sites before trying again.');
    return out;
  } finally {
    submitting.delete(key);
  }
}
